/* eslint-disable @trello/filename-case */

import Auth from 'app/scripts/db/auth.coffee';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import ReactDOM from '@trello/react-dom-wrapper';
import { dontUpsell } from '@trello/config';

interface RenderFunction {
  (args: {
    // Will dismiss the message and unmount the component
    dismiss: () => void;
  }): React.ReactChild;
}

interface UnmountFunction {
  // Returns the result of ReactDOM.unmountComponentAtNode
  (): boolean;
}

export interface BackboneOrganizationModel {
  isPremium: () => boolean;
  isEnterprise: () => boolean;
}

export interface BackboneBoardModel {
  getOrganization: () => BackboneOrganizationModel | undefined;
}

export const renderUpgradePrompt = (
  renderFunc: RenderFunction | React.ReactChild,
  container: HTMLElement,
  props: {
    boardModel?: BackboneBoardModel;
    extraCondition?: () => boolean;
    orgModel?: BackboneOrganizationModel;
    promptID?: string;
  } = {},
): UnmountFunction => {
  const { boardModel, extraCondition = () => true, orgModel, promptID } = props;

  const me = Auth.me();
  const isPromptDismissed = promptID ? me.isDismissed(promptID) : false;
  const org = orgModel || (boardModel && boardModel.getOrganization());
  const isFreeTeam = org ? !org.isPremium() && !org.isEnterprise() : false;
  const hasBCPowerUps = me.hasBCPowerUps();

  const shouldShowUpgradePrompt =
    !dontUpsell &&
    !isPromptDismissed &&
    isFreeTeam &&
    !hasBCPowerUps &&
    extraCondition();

  const unmount: UnmountFunction = () =>
    !!container && ReactDOM.unmountComponentAtNode(container);

  const dismiss = () => {
    if (promptID) {
      me.dismiss(promptID);
    }

    unmount();
  };

  const component =
    typeof renderFunc === 'function' ? renderFunc({ dismiss }) : renderFunc;

  if (container && shouldShowUpgradePrompt) {
    renderComponent(component, container);
  } else {
    unmount();
  }

  return unmount;
};
